module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-34.0fa3e93e.png";